import { GetFormDataActionTypes, GetFormDataState, GET_FORM_DATA_FAILURE, GET_FORM_DATA_REQUEST, GET_FORM_DATA_SUCCESS } from "store/reducers/lodgingRequest/getFormData/types";

const defaultState: GetFormDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function getFormData(state = defaultState, action: GetFormDataActionTypes): GetFormDataState {
  switch (action.type) {
    case GET_FORM_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_FORM_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_FORM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};